import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const client = axios.create({
  baseURL: API_URL,
  timeout: 300000,
});

client.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

client.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry) {
      original._retry = true;
      const refreshToken = localStorage.getItem('refresh_token');
      if (!refreshToken) {
        localStorage.clear();
        window.location.href = '/login';
        return Promise.reject(error);
      }
      try {
        const res = await axios.post(`${API_URL}/auth/refresh`, {
          refresh_token: refreshToken,
        });
        const { access_token, refresh_token } = res.data;
        localStorage.setItem('access_token', access_token);
        localStorage.setItem('refresh_token', refresh_token);
        original.headers.Authorization = `Bearer ${access_token}`;
        return client(original);
      } catch (e) {
        localStorage.clear();
        window.location.href = '/login';
        return Promise.reject(e);
      }
    }
    return Promise.reject(error);
  }
);

export default client;

export const login = (email, password) =>
  client.post('/auth/login', { email, password });

export const register = (data) =>
  client.post('/auth/register', data);

export const getMe = () =>
  client.get('/auth/me');

export const logout = (refresh_token) =>
  client.post('/auth/logout', { refresh_token });

export const getDogs = (search) =>
  client.get('/dogs/', { params: search ? { search } : {} });

export const getDog = (id) =>
  client.get(`/dogs/${id}`);

export const registerDog = (data) =>
  client.post('/dogs/', data);

export const getVaccinationHistory = (dogId) =>
  client.get(`/dogs/${dogId}/vaccinations`);

export const recordVaccination = (dogId, data) =>
  client.post(`/dogs/${dogId}/vaccinations`, data);

export const getInventory = () =>
  client.get('/inventory/');

export const getInventoryAlerts = () =>
  client.get('/inventory/alerts');

export const dispenseVaccine = (vaccineId, quantity) =>
  client.post(`/inventory/${vaccineId}/dispense`, null, {
    params: { quantity }
  });

export const identifyDog = (photoFile) => {
  const formData = new FormData();
  formData.append('photo', photoFile);
  return client.post('/faceid/identify', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export const enrollDog = (dogId, photoFiles) => {
  const formData = new FormData();
  photoFiles.forEach((file) => formData.append('photos', file));
  return client.post(`/faceid/enroll/${dogId}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export const getColdChainDevices = () =>
  client.get('/coldchain/devices');

export const getColdChainAlerts = () =>
  client.get('/coldchain/alerts');
